import { CaseReducer, PayloadAction, createSlice } from '@reduxjs/toolkit';

import { get } from 'api/requests';

import { loading } from 'store/common';

import { getPreparedFurnishingTabs } from '../helpers';

import { IReducer, AppThunk } from 'store/types';
import { IOptionsMedia, IOptionsGroups, IOptionGroup } from 'features/PlacementsStatus/types';

interface FurnishingState {
  loading: boolean;
  media: IOptionsMedia[] | null;
  tabs: IOptionGroup[] | null;
}

const initialState: FurnishingState = {
  loading: false,
  media: null,
  tabs: null,
};

const reset: CaseReducer<FurnishingState> = () => initialState;

const setFurnishing: CaseReducer<FurnishingState, PayloadAction<IOptionsMedia[]>> = (
  state,
  action,
) => {
  state.media = action.payload;
};

const setTabs: CaseReducer<FurnishingState, PayloadAction<IOptionGroup[]>> = (state, action) => {
  state.tabs = action.payload;
};

export const placementsFurnitureSlice = createSlice({
  name: 'furniture',
  initialState,
  reducers: {
    loading: loading as IReducer<FurnishingState, boolean>,
    setFurnishing,
    setTabs,
    reset,
  },
});

const {
  loading: setLoading,
  setFurnishing: setFurnishingData,
  setTabs: setTabsData,
  reset: setReset,
} = placementsFurnitureSlice.actions;

export const getFurnitureMedia =
  (placementId: number): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));

    get<IOptionsMedia[]>(`/api/v2/standards/placements/${placementId}/options-media/`)
      .then(({ data }) => {
        dispatch(setFurnishingData(data));
      })
      .finally(() => dispatch(setLoading(false)));
  };

export const getFurnitureTabs =
  (placementId: number): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));

    get<IOptionsGroups>(`/api/standards/placements/${placementId}/options-groups/`)
      .then(({ data }) => {
        const preparedTabs = getPreparedFurnishingTabs(data);
        dispatch(setTabsData(preparedTabs));
      })
      .finally(() => dispatch(setLoading(false)));
  };

export { setReset };
